export default __webpack_public_path__ + "static/media/Domino.54210af5.png";